import React from 'react';
import { MessageSquare } from 'lucide-react';
import { WHATSAPP_URL, WHATSAPP_NUMBER_DISPLAY } from './constants';

export default function FloatingFabs({ onOpenChat }) {
  return (
    <>
      {/* WhatsApp FAB — bottom-left */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Pedir ayuda por WhatsApp al ${WHATSAPP_NUMBER_DISPLAY}`}
        className="fixed bottom-6 left-6 z-50 h-14 px-5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white inline-flex items-center gap-2 shadow-2xl shadow-emerald-600/40 hover:scale-105 active:scale-95 transition-all"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M20.52 3.48A11.86 11.86 0 0012.06 0C5.5 0 .17 5.33.17 11.9c0 2.1.55 4.15 1.59 5.95L.07 24l6.3-1.65a11.9 11.9 0 005.69 1.45h.01c6.56 0 11.9-5.33 11.9-11.9 0-3.18-1.24-6.17-3.45-8.42zm-8.46 18.3h-.01a9.87 9.87 0 01-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 01-1.51-5.25c0-5.45 4.44-9.89 9.9-9.89 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 012.9 6.99c0 5.45-4.44 9.88-9.9 9.88zm5.42-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.26-.46-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.07c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35z"/>
        </svg>
        <span className="text-[14px] font-semibold hidden sm:inline">WhatsApp</span>
      </a>

      {/* Chat FAB — bottom-right */}
      <button
        onClick={onOpenChat}
        aria-label="Abrir chat de soporte"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-brand-600 hover:bg-brand-700 text-white inline-flex items-center justify-center shadow-2xl shadow-brand-600/40 hover:scale-110 active:scale-95 transition-all cursor-pointer"
      >
        <MessageSquare size={24} strokeWidth={2} />
      </button>
    </>
  );
}
